import { render, staticRenderFns } from "./ServicePackage.vue?vue&type=template&id=90f395d8&scoped=true&"
import script from "./ServicePackage.vue?vue&type=script&lang=js&"
export * from "./ServicePackage.vue?vue&type=script&lang=js&"
import style0 from "./ServicePackage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ServicePackage.vue?vue&type=style&index=1&id=90f395d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f395d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VMenu,VSwitch})
